// Ambient background from Plankton CRM: soft brand light patches over near-white.
export const ambientBackground = `
    radial-gradient(1200px 820px at 10% -12%, rgba(30,58,82,0.07) 0%, rgba(30,58,82,0) 55%),
    radial-gradient(1000px 720px at 102% 0%, rgba(59,94,127,0.055) 0%, rgba(59,94,127,0) 52%),
    radial-gradient(1000px 900px at 88% 116%, rgba(30,58,82,0.05) 0%, rgba(30,58,82,0) 55%),
    linear-gradient(180deg, #f6f9fb 0%, #f8fafc 100%)
`;

export const glassSurfaceStrong = {
    backgroundColor: 'rgba(255,255,255,0.88)',
    backdropFilter: 'blur(20px) saturate(140%)',
    WebkitBackdropFilter: 'blur(20px) saturate(140%)',
    border: '1px solid rgba(255,255,255,0.7)',
    borderRadius: '18px',
    boxShadow: '0 1px 2px rgba(16,42,66,0.05), 0 16px 40px -16px rgba(30,58,82,0.18)',
};
